export enum VideoQuality {
  Auto = 'auto',
  Adaptive = 'adaptive',
  X4K = 2160,
  X2K = 1440,
  X1080 = 1080,
  X720 = 720,
  X540 = 540,
  X360 = 360,
}

export type VideoElementProp = {
  id: number;
  muted: boolean;
  autoplay: boolean;
  loop: boolean;
  play: () => void;
  isDashPlayback: () => boolean;
  getAdaptiveURL: () => void;
  getFileURL: () => string;
};
